import React from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import styles from "./SpotlightCarousal.module.scss";
import cardStyles from "./UpcomingAppointmentCard.module.scss";
import CustomSkeleton from "../../../components/custom-skeleton/CustomSkeleton";

const SpotlightCarousalCustomSkeleton = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // sm = 600px

  const CustomSkeletonCount = isMobile ? 3 : 3;

  return (
    <Box className={styles.spotlightCarouselContainer}>
      {/* Greeting CustomSkeleton */}
      <Box width={"20rem"} className={styles.greetings}>
        <CustomSkeleton variant="text" width="40%" height={20} sx={{ mb: 1 }} />
        <CustomSkeleton variant="text" width="60%" height={40} />
      </Box>

      {/* Carousel CustomSkeleton */}
      <Box sx={{ display: "flex", gap: 2,}} className={styles.carouselWrapper}>
        {[...Array(CustomSkeletonCount)].map((_, index) => (
          <Box
            key={index}
            sx={{
              minWidth: 280,
              flexShrink: 0,
            }}
          >
            <Box className={cardStyles.card}>
              <Box className={cardStyles.header} sx={{
                backgroundColor: "#ffffff"
              }}>
                <CustomSkeleton variant="text" width="100%" height={40} />
              </Box>

              <Box className={cardStyles.content} sx={{alignItems: "baseline"}}>
                <Box className={cardStyles.doctorInfo}>
                  <CustomSkeleton variant="circular" width={50} height={50} />
                  <Box sx={{ marginLeft: 2 }}>
                    <CustomSkeleton variant="text" width={150} height={30} />
                    <CustomSkeleton variant="text" width={150} height={30} />
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default SpotlightCarousalCustomSkeleton; 